export function Logo({ withName = true }: { withName?: boolean }) {
  return (
    <span className="flex items-center gap-[10px]">
      <span className="relative flex h-[30px] w-[30px] flex-none items-center justify-center border-2 border-steel">
        <span className="font-mono text-[12px] font-bold tracking-[-0.5px] text-steel">PD</span>
        <span className="absolute -bottom-[2px] -right-[2px] h-[7px] w-[7px] bg-signal" />
      </span>
      {withName ? <span className="font-display text-[19px] font-semibold text-ink">PortDwellr</span> : null}
    </span>
  );
}
